var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99989 10.5C9.3806 10.5 10.4999 9.38071 10.4999 8C10.4999 6.61929 9.3806 5.5 7.99989 5.5C6.61917 5.5 5.49989 6.61929 5.49989 8C5.49989 9.38071 6.61917 10.5 7.99989 10.5Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 8C13.4999 7.535 13.4359 7.087 13.3279 6.656L15.2449 5.549L13.7449 2.951L11.8299 4.057C11.1859 3.431 10.3889 2.964 9.49988 2.713V0.5H6.49988V2.712C5.61188 2.964 4.81488 3.431 4.16988 4.057L2.25488 2.951L0.754883 5.549L2.67188 6.656C2.56388 7.087 2.49988 7.535 2.49988 8C2.49988 8.464 2.56388 8.913 2.67188 9.344L0.754883 10.451L2.25488 13.049L4.17088 11.943C4.81488 12.569 5.61188 13.036 6.50088 13.287V15.5H9.50088V13.288C10.3899 13.036 11.1859 12.569 11.8309 11.944L13.7469 13.05L15.2469 10.452L13.3299 9.345C13.4359 8.913 13.4999 8.464 13.4999 8Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.3da99f9052350cef66e366e342064363.svg";
export { ForwardRef as ReactComponent };